"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dropDown = _interopRequireDefault(require("@clayui/drop-down"));

var _shared = require("@clayui/shared");

var _classnames = _interopRequireDefault(require("classnames"));

var _fuzzy = _interopRequireDefault(require("fuzzy"));

var _react = _interopRequireWildcard(require("react"));

var _Context = require("./Context");

var _excluded = ["children", "className", "disabled", "innerRef", "keyValue", "match", "textValue", "value"],
    _excluded2 = ["children", "innerRef", "match", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var optionsFuzzy = {
  post: '|}',
  pre: '}|'
};

var NewItem = /*#__PURE__*/_react.default.forwardRef(function NewItem(_ref, ref) {
  var _ref2;

  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      innerRef = _ref.innerRef,
      keyValue = _ref.keyValue,
      _ref$match = _ref.match,
      match = _ref$match === void 0 ? '' : _ref$match,
      textValue = _ref.textValue,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useAutocompleteState = (0, _Context.useAutocompleteState)(),
      activeDescendant = _useAutocompleteState.activeDescendant,
      onActiveDescendant = _useAutocompleteState.onActiveDescendant;

  var _useInteractionFocus = (0, _shared.useInteractionFocus)(),
      isFocusVisible = _useInteractionFocus.isFocusVisible;

  var isFocus = isFocusVisible();
  var hoverProps = (0, _shared.useHover)({
    disabled: disabled,
    onHover: (0, _react.useCallback)(function () {
      return !isFocus && onActiveDescendant(keyValue);
    }, [keyValue, isFocus])
  });
  var currentValue = (_ref2 = textValue !== null && textValue !== void 0 ? textValue : value) !== null && _ref2 !== void 0 ? _ref2 : String(children);

  var fuzzyMatch = _fuzzy.default.match(match, currentValue, optionsFuzzy);

  return /*#__PURE__*/_react.default.createElement(_dropDown.default.Item, _extends({}, otherProps, hoverProps, {
    "aria-selected": activeDescendant === keyValue,
    className: (0, _classnames.default)(className, {
      focus: activeDescendant === keyValue && isFocus,
      hover: activeDescendant === keyValue && !isFocus
    }),
    id: String(keyValue),
    innerRef: innerRef,
    ref: ref,
    tabIndex: -1
  }), match && fuzzyMatch && typeof children === 'string' ? fuzzyMatch.rendered.split('|').map(function (item, index) {
    var Text = item.includes('}') ? 'span' : 'strong';
    var value = item.replace(/\}/g, '');
    return value ? /*#__PURE__*/_react.default.createElement(Text, {
      className: !item.includes('}') ? 'mark' : undefined,
      key: index
    }, value) : null;
  }).filter(Boolean) : children !== null && children !== void 0 ? children : currentValue);
});

var ItemLegacy = /*#__PURE__*/_react.default.forwardRef(function ItemLegacy(_ref3, ref) {
  var children = _ref3.children,
      innerRef = _ref3.innerRef,
      _ref3$match = _ref3.match,
      match = _ref3$match === void 0 ? '' : _ref3$match,
      value = _ref3.value,
      otherProps = _objectWithoutProperties(_ref3, _excluded2);

  var currentValue = value !== null && value !== void 0 ? value : String(children);

  var fuzzyMatch = _fuzzy.default.match(match, currentValue, optionsFuzzy);

  return /*#__PURE__*/_react.default.createElement(_dropDown.default.Item, _extends({}, otherProps, {
    innerRef: innerRef,
    ref: ref
  }), match && fuzzyMatch ? fuzzyMatch.rendered.split('|').map(function (item, index) {
    var Text = item.includes('}') ? 'span' : 'strong';
    var value = item.replace(/\}/g, '');
    return value ? /*#__PURE__*/_react.default.createElement(Text, {
      key: index
    }, value) : null;
  }).filter(Boolean) : currentValue);
});

var Item = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _useAutocompleteState2 = (0, _Context.useAutocompleteState)(),
      onActiveDescendant = _useAutocompleteState2.onActiveDescendant;

  var Component = onActiveDescendant ? NewItem : ItemLegacy;
  return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
    ref: ref
  }));
});

Item.displayName = 'Item';
var _default = Item;
exports.default = _default;